module.exports = __webpack_public_path__ + "assets/img/jieshao6.a6dd62b4.svg";